// extracted by mini-css-extract-plugin
export var dropdown = "_is-0";
export var imagePlaceholder = "_is-2";
export var imageWrapper = "_is-3";
export var productImage = "_is-1";
export var truncateContainer = "_is-4";
export var truncateText = "_is-5";